<div class="flex flex-col gap-16 p-5">
  <!-- Sección de la cabecera. -->
  <section class="w-full flex flex-col items-center gap-5">
    <div class="text-2xl font-medium text-center">Crear un producto</div>
  </section>

  <!-- Sección del cuerpo. -->
  <section>
    <!-- Formulario. -->
    <form class="flex flex-col" [formGroup]="form" (ngSubmit)="create()">
      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input type="text" name="name" formControlName="name" matInput />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Descripción</mat-label>
        <textarea
          name="description"
          formControlName="description"
          matInput
        ></textarea>
      </mat-form-field>

      <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-3">
          <div class="flex items-center flex-wrap gap-3">
            <label
              for="image"
              class="bg-[#005cbb] hover:bg-[#005cbbe8] text-white py-2 px-4 rounded-full cursor-pointer text-nowrap select-none"
            >
              Seleccionar imagen
            </label>
            <input
              type="file"
              id="image"
              name="image"
              hidden
              accept="image/*"
              (change)="onChangeImage($event)"
            />
            @if (selectedImage) {
            <span class="text-gray-700 text-sm">
              {{ selectedImage.name }}
            </span>
            }
          </div>
          <div class="text-gray-500 text-sm">
            Solo se permite una imagen PNG, JPG o JPEG de hasta 2MB.
          </div>
        </div>
        @if(errorOnChangeImage) {
        <div class="text-sm text-red-500">{{ errorOnChangeImage }}</div>
        } @if (previewImage) {
        <div class="text-sm text-gray-500">Previsualización:</div>
        <div class="flex justify-center">
          <img
            [src]="previewImage"
            alt="Previsualización"
            class="h-40 w-40 rounded-full shadow"
          />
        </div>
        }
      </div>

      <mat-slide-toggle formControlName="status" class="mt-5">
        <span class="text-base pl-2">{{
          formStatus?.value ? "Activo" : "Deshabilitado"
        }}</span>
      </mat-slide-toggle>

      <!-- Errores. -->
      @if (errorsOnCreate) {
      <div class="flex flex-col gap-2 text-center mt-10">
        @for (error of errorsOnCreate; track error) {
        <span class="text-sm text-red-500">{{ error }}</span>
        }
      </div>
      }

      <!-- Botón de acción. -->
      <button
        type="submit"
        mat-flat-button
        class="mt-10"
        [disabled]="form.invalid || loading"
      >
        @if (loading) {
        <mat-spinner diameter="18"></mat-spinner>
        } @else {
        <span class="text-base">Crear</span>
        }
      </button>
    </form>
  </section>
</div>
